import React from 'react';
import styles from './DancingBar.module.css';

const DancingBar = () => {
  return (
    <>
    <div className={styles.dancing_bar}></div>
    <div className={styles.dancing_bar}></div>
    <div className={styles.dancing_bar}></div>
    <div className={styles.dancing_bar}></div>
    <div className={styles.dancing_bar}></div>
    <div className={styles.dancing_bar}></div>
    <div className={styles.dancing_bar}></div>
    <div className={styles.dancing_bar}></div>
    <div className={styles.dancing_bar}></div>
    <div className={styles.dancing_bar}></div>
    <div className={styles.dancing_bar}></div>
    
    </>
  );
};

export default DancingBar;
